import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=52de49a0"
import script from "./OrderView.vue?vue&type=script&lang=ts"
export * from "./OrderView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports